import React, { useState } from "react";
import * as c from "./exploreFeature.module.scss";
import classNames from "classnames";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { IconCaretRight } from "@components/icons/IconCaretRight";
import { IconExpandCollapseArrow } from "@components/icons/IconExpandCollapseArrow";

const ExploreFeatures = ({ features: { heading, listItems } }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleExpand = () => setIsOpen(!isOpen);

  const categoryOrder = ["Scheduling & Payments", "Client Relationships", "Marketing & Automation", "Management"];

  const groupedItems = listItems.reduce((acc, item) => {
    if (!acc[item.category]) {
      acc[item.category] = [];
    }
    acc[item.category].push(item);
    return acc;
  }, {});

  return (
    <div className={c.container}>
      <div className={classNames(c.featuresWrap, { [c.open]: isOpen })}>
        <div className={c.features}>
          {categoryOrder.map((category) => {
            return (
              <div key={category} className={c.categoryColumn}>
                <p className={classNames("eyebrow", c.eyebrow)}>{category}</p>
                <div className={c.categoryItems}>
                  {(groupedItems[category] || []).map(({ title, icon, url }) => (
                    <Link className={c.feature} to={url} key={url}>
                      <GatsbyImage image={getImage(icon)} className={classNames(c.icon)} alt={`${title} icon`} />
                      <div className={c.text}>
                        <h4 className={c.title}>{title}</h4>
                      </div>
                      <div className={c.caret}>
                        <IconCaretRight isRedesign stroke="#191E49" />
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className={c.seeMoreContainer}>
        <span className={classNames(c.seeMore, "eyebrow", isOpen && c.seeLess)} onClick={toggleExpand}>
          {isOpen ? "See less" : "See more"}
          <IconExpandCollapseArrow stroke="#191E49" />
        </span>
      </div>
    </div>
  );
};

export default ExploreFeatures;
